
import Vue from 'vue';
import { Icon } from '@descomplica/vue-components';

export default Vue.extend({
  components: {
    Icon,
  },
  props: {
    isClosable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isVisible: true,
    };
  },
  methods: {
    closeHandler(): void {
      this.isVisible = !this.isVisible;
    },
  },
});
